<template>
  <div class="yhc-component YhcColorPicker" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>
    <div class="content">
      <el-color-picker
        @change="change"
        :disabled="onlyRead"
        class="el-component-item"
        style="width: auto"
        v-model="result"
      ></el-color-picker>
    </div>
    <PrivateEndLabel
      v-if="endLabel"
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

let identifierName = 'YhcColorPicker';

export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin],

  data() {
    return {
      result: this.value,
    };
  },

  props: {
    value: {
      type: [String],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  watch: {
    value(newVal, oldVal) {
      this.result = newVal;
    },
  },
  methods: {
    change() {
      this.$emit('change', this.result, this.index);
      this.$emit('input', this.result, this.index);
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcColorPicker {
  @include labelCommon();
}
</style>
